<template>
  <el-form-item label="客户" prop="customerNo">
    <el-select
      v-model="customerNo"
      placeholder="请选择客户"
      style="width: 100%;"
      filterable
      clearable
      :disabled="disabled"
    >
      <el-option
        v-for="item in customers"
        :key="item.id"
        :label="item.customerShortName"
        :value="item.customerNo"
      ></el-option>
    </el-select>
  </el-form-item>
</template>

<script>
export default {
    data() {
        return{
            customers:[],
            customerNo:"",
            disabled:false,
        }
    },
    created: function() {
    console.log("cust selector created");
    var self = this;
      this.$axios
        .get("customer/queryAll")
        .then(function(response) {
          if (response.data.errorCode == "00000") {
            self.customers = response.data.data;
          } else {
            self.$message.error(response.data.errorMsg);
          }
        });
  }
}
</script>